import { Alert, Button, CircularProgress, Stack, Typography } from '@mui/material';

/**
 * What a report shows in place of figures it is still fetching. Without it a page reads as empty,
 * and on a report that is the same as "nothing happened", which is the one thing it must not say
 * before it knows.
 */
export const Loading = ({ text }: { text: string }) => (
  <Stack direction='row' spacing={1.5} alignItems='center'>
    <CircularProgress size={18} thickness={5} />
    <Typography variant='body2' color='text.secondary'>{text}</Typography>
  </Stack>
);

/**
 * What a report shows in place of figures it could not fetch, with a way to ask again. The request's
 * own message still goes to the snackbar, which disappears; this stays, so a failure is never read
 * as no use.
 */
export const LoadFailed = ({ text, onRetry }: { text: string, onRetry: () => void }) => (
  <Alert severity='error' action={<Button color='inherit' size='small' onClick={onRetry}>Try again</Button>}>
    {text}
  </Alert>
);
